export default "__VITE_ASSET__4195ed5e__"